import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import submissionActions from './submission-actions'


/*

Most times when you make a request to an endpoint, you want to automatically update the
state.fields state automatically based on the response. This module essentially provides a 
wrapper around Axios, for this application specific handling of requests and responses made to
the chustratatech api. By utilising the actions of this module, it will also accomidate for
obscure error response handling, such as handling errors or empty data in 200 status responses. 

*/

const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    submission: state.submission
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        submission: bindActionCreators( submissionActions, dispatch )
    }
})


export const withSubmission = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/submission/index.tsx